"use client";

import { memo } from "react";
import type { IndustryLanguagesProps } from "./types";
import { industryLanguagesData } from "./constants";
import {
  LanguagesSection,
} from "@/components/screen/global-components/language";

const IndustryLanguages = ({
  className,
}: IndustryLanguagesProps) => {
  return (
    <LanguagesSection
      className={className}
      {...industryLanguagesData}
    />
  );
};

export default memo(IndustryLanguages);
